module.exports = __webpack_public_path__ + "img/Trustpilot_ratings_2star-RGB.a3197695.svg";